export const REMOTE_DOORMAN_SETTINGS = 'RemoteDoormanSettings';

export const ACCOUNTING_FORM = {
  accountingSystemIdentifier: {
    key: 'accountingSystemIdentifier',
    label: 'Accounting System Identifier',
  },
  accountingSystemUnitNamePrefix: {
    key: 'accountingSystemUnitNamePrefix',
    label: 'Accounting System Unit Name Prefix',
  },
  includedUnitsNamePrefix: {
    key: 'includedUnitsNamePrefix',
    label: 'Included Units Name Prefix',
  },
  removeResidentsNotInAccountingSystem: {
    key: 'removeResidentsNotInAccountingSystem',
    label: 'Remove Residents not in Accounting System',
  },
  skipInviteToAccountingSystemResidents: {
    key: 'skipInviteToAccountingSystemResidents',
    label: 'Skip Invite to Accounting System Residents',
  },
};

export const ACCOUNTING_FORM_YARDI = {
  ...ACCOUNTING_FORM,
  multipleYardiProperties: {
    key: 'multipleYardiProperties',
    label: 'Multi property set up',
  },
  residentsAutoSyncEnabled: {
    key: 'residentsAutoSyncEnabled',
    label: 'Enable Residents Auto-Sync',
  },
  serviceRequestsAutoSyncEnabled: {
    key: 'serviceRequestsAutoSyncEnabled',
    label: 'Enable Service Requests Auto-Sync',
  },
  isDefaultForServiceRequestsExport: {
    key: 'isDefaultForServiceRequestsExport',
    label: 'Default property for Service Request Export',
  },
  yardiPropertyId: {
    key: 'yardiPropertyId',
    label: 'Property Id',
  },
  wsdl: {
    key: 'wsdl',
    label: 'Url',
  },
  username: {
    key: 'username',
    label: 'Username',
  },
  password: {
    key: 'password',
    label: 'Password',
  },
  serverName: {
    key: 'serverName',
    label: 'Server Name',
  },
  database: {
    key: 'database',
    label: 'Database',
  },
  platform: {
    key: 'platform',
    label: 'Platform',
  },
  interfaceEntity: {
    key: 'interfaceEntity',
    label: 'Interface Entity',
  },
};

export const SYNC_ACCOUNT_TYPE = {
  bmx: 'bmx',
  brivo: 'brivo',
  comelit: 'comelit',
  dormakaba: 'dormakaba',
  salto: 'salto',
  smartair: 'smartair',
  twoN: '2n',
  lyazon: 'lyazon',
  zerv: 'zerv',
  keyscan: 'keyscan',
};

export const ACCOUNTS_DATA = {
  accessControlAccount: {
    name: 'Access Control Account',
    type: 'access-control-account',
    options: [
      {
        label: 'Brivo Account',
        value: 'brivo',
      },
      {
        label: 'Smartair Account',
        value: 'smartair',
      },
      {
        label: '2N',
        value: 'two-n',
      },
      {
        label: 'Akuvox',
        value: 'akuvox',
      },
      {
        label: 'Comelit Account',
        value: 'comelit',
      },
      {
        label: 'BMX Account',
        value: 'bmx',
      },
      {
        label: 'Dormakaba',
        value: 'dormakaba',
      },
      {
        label: 'Lyazon',
        value: 'Lyazon',
      },
      {
        label: 'Zerv',
        value: 'zerv',
      },
      {
        label: 'Salto',
        value: 'salto',
      },
      {
        label: 'Keyscan',
        value: 'keyscan',
      },
    ],
  },
  accountingAccount: {
    name: 'Accounting Account',
    type: 'accounting-account',
    options: [
      {
        label: 'Yardi Account',
        value: 'yardi',
        options: [
          {
            label: 'Resident Updates Daily Report (File import)',
            value: 'yardi-file-import',
          },
          {
            label: 'Set Up Auto Sync (API)',
            value: 'yardi',
          },
        ],
      },
      {
        label: 'Mri Account',
        value: 'mri',
      },
      {
        label: 'Appfolio Account',
        value: 'appfolio',
      },
      {
        label: 'MDS Account',
        value: 'mds',
      },
    ],
  },
  cameraAccount: {
    name: 'Camera Account',
    type: 'camera-account',
    options: [
      {
        label: 'EagleEye Account',
        value: 'eagle-eye',
      },
    ],
  },

  paymentAccount: {
    name: 'Payment Account',
    type: 'payment-account',
    options: [
      {
        label: 'Aptexx Account',
        value: 'aptexx',
      },
      {
        label: 'Clickpay Account',
        value: 'clickpay',
      },
      {
        label: 'External Account',
        value: 'external',
      },
    ],
  },

  customLinks: {
    name: 'Custom Links',
    type: 'custom-links',
    options: [
      {
        label: 'Custom Links',
        value: 'custom-links',
      },
    ],
  },
};

export const CARDS_TARGET_IDS = {
  propertySettings: 'property-settings',
  generalSettings: 'general-settings',
  remoteDoorman: 'remote-doorman',
  leasing: 'leasing',
  integrationsStatus: 'integrations-status',
  accessControlAccount: 'access-control-accounts',
  accountingAccount: 'accounting-accounts',
  cameraAccount: 'cameras-accounts',
  paymentAccount: 'payments-accounts',
  deliveryTypes: 'delivery-types',
  visitorSettings: 'visitor-settings',
  amenityReservationSettings: 'amenity-reservation-settings',
  serviceRequestCategoriesSettings: 'service-request-categories-settings',
  customLinks: 'custom-links',
};

export const WAIT_TIME_OPTIONS = [
  {
    label: '0 seconds (straight to the voicemail)',
    value: '0',
  },
  {
    label: '5 seconds',
    value: '5',
  },
  {
    label: '10 seconds',
    value: '10',
  },
];

export const PAYMENTS_SYNC_FREQUENCY_OPTIONS = [
  {
    label: 'Daily',
    value: 'daily',
  },
  {
    label: 'Weekly',
    value: 'weekly',
  },
  {
    label: 'Monthly',
    value: 'monthly',
  },
];
